import React from 'react';
import { Users, MessageSquare, Heart, Handshake, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CommunityFirst() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link to="/about" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Back to About
        </Link>

        <div className="mb-12">
          <div className="inline-flex items-center gap-3 bg-primary/10 border border-primary/30 rounded-full px-6 py-3 mb-6">
            <Users className="w-6 h-6 text-primary" />
            <span className="text-primary font-semibold">Our Philosophy</span>
          </div>
          <h1 className="text-5xl font-heading font-bold mb-6">Community First</h1>
          <p className="text-xl text-muted-foreground">
            Poker is a social game. We emphasize friendly interaction, mutual respect, and helping each other improve.
          </p>
        </div>

        <div className="prose prose-invert max-w-none">
          <div className="bg-card border border-border rounded-2xl p-8 mb-8">
            <h2 className="text-2xl font-heading font-bold mb-4 flex items-center gap-3">
              <Heart className="w-6 h-6 text-primary" />
              Why Community Matters
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Poker is more than just cards and chips—it's about the people you play with. At Luck or Skills, 
              we believe the social aspect of poker is what makes it truly special. Our community is built on 
              the foundation of respect, encouragement, and genuine human connection.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              We've created a space where beginners feel comfortable asking questions, experienced players 
              enjoy sharing knowledge, and everyone treats each other with kindness and respect.
            </p>
          </div>

          <div className="bg-card border border-border rounded-2xl p-8 mb-8">
            <h2 className="text-2xl font-heading font-bold mb-4 flex items-center gap-3">
              <MessageSquare className="w-6 h-6 text-primary" />
              How We Foster Community
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold mb-2 text-primary">Live Discussions</h3>
                <p className="text-muted-foreground">
                  Our weekly live sessions aren't lectures—they're conversations. Members actively participate, 
                  share hands they've played, and learn from each other's experiences.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-primary">Active Forum</h3>
                <p className="text-muted-foreground">
                  Between live sessions, our forum stays active with strategy discussions, hand analysis, 
                  and general poker talk. Members build friendships that extend beyond the game.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-primary">Supportive Environment</h3>
                <p className="text-muted-foreground">
                  Every member is encouraged to contribute, regardless of experience level. We celebrate 
                  progress, offer constructive feedback, and maintain a judgment-free space for learning.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-card border border-border rounded-2xl p-8">
            <h2 className="text-2xl font-heading font-bold mb-4 flex items-center gap-3">
              <Handshake className="w-6 h-6 text-primary" />
              Our Community Values
            </h2>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold mt-1">•</span>
                <span><strong>Respect:</strong> We treat every member with dignity, regardless of skill level or background.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold mt-1">•</span>
                <span><strong>Encouragement:</strong> We celebrate wins and support each other through losses.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold mt-1">•</span>
                <span><strong>Knowledge Sharing:</strong> Experienced players freely share insights with newcomers.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold mt-1">•</span>
                <span><strong>Friendly Competition:</strong> We push each other to improve while keeping it fun and friendly.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold mt-1">•</span>
                <span><strong>Authentic Relationships:</strong> Members form real friendships that go beyond poker.</span>
              </li>
            </ul>
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/membership" 
              className="inline-flex items-center gap-3 bg-primary hover:bg-primary/90 text-black px-8 py-4 rounded-xl font-bold text-lg transition-all transform hover:scale-105"
            >
              Join Our Community
              <Users className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}